<template>
	<div class="profile">
		<div class="vx-row">
			<div class="vx-col lg:w-1/4 w-full mb-10">
				<vx-card>
					<div
						class="flex justify-between items-center box-top profile-widget"
					>
						<div class="des w-full">
							<div class="profile-widget__big">
								{{ countTask.count }}
							</div>
							<p>{{ $t("totalOrdersCount") }}</p>
						</div>
						<div class="icon">
							<feather-icon icon="ListIcon"></feather-icon>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-col lg:w-1/4 w-full mb-10">
				<vx-card>
					<div
						class="flex justify-between items-center box-top profile-widget"
					>
						<div class="des">
							<div class="profile-widget__big">
								<span class="profile-widget__success">{{
									countTaskActive.count_success
								}}</span>
								/
								<span class="profile-widget__danger">{{
									countTaskActive.count_fail
								}}</span>
							</div>
							<p>{{ $t("success") }}</p>
						</div>
						<div class="icon">
							<feather-icon icon="ThumbsUpIcon"></feather-icon>
						</div>
					</div>
				</vx-card>
			</div>
			<div
				v-if="penaltyCount"
				class="info-card vx-col lg:w-1/4 w-full mb-10"
			>
				<vx-card>
					<div
						class="flex justify-between items-center box-top h-full"
					>
						<div class="des w-full">
							<span class="info-card__value">{{
								penaltyCount
							}}</span>
							<p class="info-card__title">
								{{ $t("penaltyCount") }}
							</p>
						</div>
						<div
							class="icon text-danger ml-3"
							:style="{
								background: `rgba(var(--vs-danger),.15)`
							}"
						>
							<feather-icon
								color="#3AC47D"
								icon="CreditCardIcon"
							></feather-icon>
						</div>
					</div>
				</vx-card>
			</div>
		</div>

		<div class="vx-row">
			<div class="vx-col w-full mb-5">
				<vx-card>
					<h1>{{ $t("profile") }}</h1>
					<div class="info mt-5 flex flex-col sm:flex-row">
						<div class="photo">
							<img :src="model.photo" alt="" />
						</div>
						<div class="data">
							<div class="tables vx-row">
								<table class="vx-col w-full lg:w-1/2">
									<tbody>
										<tr>
											<td>{{ $t("personName") }}</td>
											<td>{{ model.username }}</td>
										</tr>
										<tr>
											<td>{{ $t("birthDate") }}</td>
											<td>{{ birthDateOutput }}</td>
										</tr>
										<tr>
											<td>{{ $t("sex") }}</td>
											<td>
												{{
													$getDeep(
														model.gender,
														genders
													)
												}}
											</td>
										</tr>
										<tr>
											<td>{{ $t("email") }}</td>
											<td>{{ model.email }}</td>
										</tr>
										<tr>
											<td>{{ $t("phone") }}</td>
											<td>{{ model.phone }}</td>
										</tr>
									</tbody>
								</table>
								<table
									class="vx-col w-full lg:w-1/2 mt-10 lg:mt-0"
								>
									<tbody>
										<tr>
											<td>{{ $t("subjects") }}</td>
											<td>
												<div class="d-flex flex-wrap">
													{{ subjectsOutput }}
												</div>
											</td>
										</tr>
										<tr>
											<td>{{ $t("undesirableSubjects") }}</td>
											<td>
												<div class="d-flex flex-wrap">
													{{ undesirableSubjectsOutput }}
												</div>
											</td>
										</tr>
										<tr>
											<td>{{ $t("country") }}</td>
											<td>
												{{
													$getDeep(
														model.country,
														countries
													)
												}}
											</td>
										</tr>
										<tr>
											<td>{{ $t("language") }}</td>
											<td>
												<div class="d-flex flex-wrap">
													{{ languagesOutput }}
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div class="about">
								<b>{{ $t("aboutYourself") }}</b>
								<p>{{ model.about }}</p>
							</div>
							<div class="about mt-2">
								<b>{{ $t("Description") }}</b>
								<p>{{ model.description }}</p>
							</div>
							<div class="about mt-2">
								<b>{{ $t("Status") }}</b>
								<p>{{ publicStatus }}</p>
							</div>
							<div class="about mt-2">
								<b>{{ $t("order_limit") }}</b>
								<p>{{ model.order_limit }}</p>
							</div>
						</div>
					</div>
					<vs-button
						v-if="this.$store.state.auth.role === 'admin'"
						class="mt-10"
						@click="$router.push($route.path + '/edit')"
						>{{ $t("edit") }}</vs-button
					>
				</vx-card>
			</div>
		</div>

		<div v-if="penaltyTable.length" class="vx-row">
			<div class="vx-col w-full mb-5">
				<vx-card>
					<vs-table
						max-items="10"
						pagination
						:data="penaltyTable"
						class="table-th-center"
					>
						<template slot="thead">
							<vs-th
								v-for="fil in penaltyTableFields"
								class="justify-center text-start"
								:sort-key="fil.field.split('.')[0]"
							>
								{{ fil.title }}
							</vs-th>
						</template>

						<template slot-scope="{ data }">
							<vs-tr :key="indextr" v-for="(tr, indextr) in data">
								<template v-for="fil in penaltyTableFields">
									<vs-td
										v-if="fil.field === 'date'"
										:class="{
											'text-center':
												fil.align &&
												fil.align === 'center'
										}"
									>
										{{ tr[fil.field] }}
									</vs-td>

									<vs-td
										:class="{
											'text-center':
												fil.align &&
												fil.align === 'center'
										}"
										v-else-if="fil.field === 'order_id'"
									>
										{{ tr[fil.field] }}
									</vs-td>

									<vs-td
										:class="{
											'text-center':
												fil.align &&
												fil.align === 'center'
										}"
										v-else-if="fil.field === 'amount'"
									>
										{{ tr[fil.field] }}
									</vs-td>

									<vs-td
										:class="{
											'text-center':
												fil.align &&
												fil.align === 'center'
										}"
										v-else-if="
											fil.field === 'penalty_reason'
										"
									>
										{{ tr[fil.field] }}
									</vs-td>

									<vs-td
										:class="{
											'text-center':
												fil.align &&
												fil.align === 'center'
										}"
										v-else
									>
										...
									</vs-td>
								</template>
							</vs-tr>
						</template>
					</vs-table>
				</vx-card>
			</div>
		</div>

		<AuthorsCommentsList
			v-if="userRole !== 'author'"
			:author-id="authorId"
			class="mt-3"
		/>
	</div>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import AuthorsCommentsList from '@/components/authors/authors-comments-list/AuthorsCommentsList.vue'

export default {
	name: "Author",
	mixins: [databaseManager, notifier],

	components: {
		AuthorsCommentsList,
	},

	data() {
		return {
			popupActive: false,
			val: "",
			description: "",
			countries: [],
			genders: [],
			languages: [],
			subjects: [],
			countTask: {},
			countTaskActive: {},
			model: {},
			penaltyData: null,
			penaltyTableFields: [
				{
					field: "date",
					title: this.$t("date")
				},
				{
					field: "order_id",
					title: this.$t("order")
				},
				{
					field: "amount",
					title: this.$t("penaltyAmount")
				},
				{
					field: "penalty_reason",
					title: this.$t("penaltyReason")
				}
			]
		};
	},
	computed: {
		userRole() {
			return this.$store.state.auth.role;
		},
		authorId() {
			return this.$route.params.id || null;
		},
		languagesOutput() {
			if (
				!this.model === undefined ||
				!this.model.languages ||
				!this.model.languages.length
			)
				return;

			return this.model.languages
				.map(el => el[`name_${this.locale}`])
				.join(", ");
		},
		undesirableSubjectsOutput() {
			if (!this.model === undefined || !this.model.undesirable_subjects) return null;

			let output = [];
			for (let undesirable_subject of this.model.undesirable_subjects) {
				output.push(this.$getDeep(undesirable_subject, this.subjects));
			}
			return output.join(", ");
		},
		subjectsOutput() {
			if (!this.model === undefined || !this.model.subjects) return null;

			let output = [];
			for (let subject of this.model.subjects) {
				output.push(this.$getDeep(subject, this.subjects));
			}
			return output.join(", ");
		},
		birthDateOutput() {
			if (!this.model === undefined || !this.model.birth_date)
				return null;

			return this.model.birth_date
				.split("-")
				.reverse()
				.join(".");
		},
		penaltyCount() {
			return this.penaltyData ? this.penaltyData.count : 0;
		},
		penaltyTable() {
			return this.penaltyData ? this.penaltyData.data : [];
		},
		publicStatus() {
			const mapping = {
				'new': 'New registration',
				'assign': 'Assign',
				'assign_newbie': 'Assign (newbie)',
				'not_assign': 'Do NOT assign',
				'risk_zone_low': 'Risk zone - low',
				'risk_zone_medium': 'Risk zone - medium',
				'risk_zone_high': 'Risk zone - high',
				'probation': 'Probation',
				'to_be_deleted': 'To be deleted',
			};
			return mapping.hasOwnProperty(this.model.status) ? mapping[this.model.status] : 'New registration';
		}
	},
	async mounted() {
		try {
			this.languages = (
				await this.$http.get("/settings/get-languages")
			).data.data;
			this.subjects = (
				await this.$http.get("/settings/get-subjects")
			).data.data;
			this.countries = (
				await this.$http.get("/settings/get-countries")
			).data.data;
			this.genders = (
				await this.$http.get("/settings/get-genders")
			).data.data;

			const role = this.$store.state.auth.role;
			if (role === "admin") {
				this.model = (
					await this.$http(
						`/${role}/author/view/${this.$route.params.id}`
					)
				).data.data;
			} else if (role === "manager") {
				this.model = (
					await this.$http(
						`/${role}/author/profile/${this.$route.params.id}`
					)
				).data.data;
			}

			this.countTask = (
				await this.$http.get(
					`/${role}/author/get-orders-completed-count/${this.$route.params.id}`
				)
			).data.data;
			this.countTaskActive = (
				await this.$http.get(
					`/${role}/author/get-success-rate/${this.$route.params.id}`
				)
			).data.data;

			this.penaltyData = await this.loadPenaltyData(this.authorId);
		} catch (e) {
			console.log(e);
		}
	},

	methods: {
		async loadPenaltyData(id) {
			try {
				return await this.dbGetAuthorPenaltyList(id);
			} catch (e) {
				this.notifyError(e.message);
			}
		}
	}
};
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables";
@import "../../assets/scss/vuexy/functions";

.profile {
	.info-card {
		&__value {
			font-size: 21px;
			font-weight: 600;
		}

		.icon {
			display: flex;
			align-items: center;
			padding: 13px;
			border-radius: 10px;
			font-size: 20px;

			svg {
				width: 27px;
				height: 27px;
			}
		}

		@media screen and (min-width: 1501px) {
			width: 20% !important;
		}
	}
	.data {
		width: 100%;
	}

	&-widget {
		&__big {
			font-size: 18px;
			font-weight: 600;
		}

		&__success {
			color: $success;
		}

		&__danger {
			color: $danger;
		}
	}

	h1 {
		font-size: 18px;
		color: #626262;
		margin-bottom: 15px;
		font-weight: 700;
	}

	.vx-card {
		height: 100%;
	}

	.info {
		display: flex;

		.tables {
			display: flex;
		}

		table {
			max-width: 550px;
			margin-bottom: 20px;
			padding-left: 15px;

			tr {
				td {
					padding-bottom: 7px;
					width: 50%;

					&:first-child {
						vertical-align: top;
						max-width: 250px;
						font-weight: 600;
					}
				}
			}
		}

		.about {
			display: flex;

			b {
				flex-shrink: 0;
				max-width: 258px;
				width: 25%;
			}

			@media screen and (max-width: 992px) {
				b {
					width: 50%;
				}
			}
		}
	}

	.photo {
		width: 150px;
		height: 150px;
		border-radius: 10px;
		overflow: hidden;
		margin-right: 30px;
		margin-bottom: 15px;
		flex-shrink: 0;

		img {
			max-width: 100%;
			width: 100%;
			height: 100%;
		}
	}

	.box {
		display: flex;
		font-size: 25px;
		align-items: center;
		margin-bottom: 22px;
	}

	.bottom {
		display: flex;
		justify-content: flex-end;
	}
}

.vs-popup {
	max-width: 400px !important;

	.vs-textarea {
		height: 100px;
	}

	&--title {
		h3 {
			color: $warning;
		}
	}

	p {
		padding: 1rem;
	}

	&--button {
		display: flex;
		justify-content: flex-end;
		border-top: 1px solid #e4e4e4;
		padding: 1rem;
		padding-bottom: 0.5rem;
	}
}
</style>
